import { Lightning, Utils } from '@lightningjs/sdk';
import { Theme } from '../config/theme';
import { DetailDescription } from '../pages/detail/DetailDescription';

export const _constants = {
  miniDetailHeight: 318,
  topBorderHeight: 2,
  Description: {
    marginLeft: 162,
    marginTop: 30,
  },
  PosterImage: {
    width: 740,
    height: 318,
    Gradients: {
      endPoint: 0.5,
      startColor: 0xff000000,
      endColor: Theme.Colors.Transparent,
    },
  },
};

export class MiniDetail extends Lightning.Component {
  static _template() {
    return {
      w: w => w,
      h: _constants.miniDetailHeight,
      rect: true,
      color: Theme.Colors.MiniDetail.background,
      src: Utils.asset('/images/detail/background_gradient.png'),
      TopBorder: {
        w: w => w,
        h: _constants.topBorderHeight,
        rect: true,
        color: Theme.Colors.Primary,
      },
      Content: {
        y: _constants.topBorderHeight,
        w: w => w,
        h: h => h - _constants.topBorderHeight,
        Poster: {
          flexItem: false,
          x: w => w,
          mountX: 1,
          w: _constants.PosterImage.width,
          h: _constants.PosterImage.height,
          PosterImage: {
            w: w => w,
            h: h => h,
            texture: {
              type: Lightning.textures.ImageTexture,
              src: '',
              resizeMode: {
                type: 'cover',
                w: _constants.PosterImage.width,
                h: _constants.PosterImage.height,
              },
            },
            shader: {
              type: Lightning.shaders.FadeOut,
              left: 400,
              bottom: 100,
            },
          },
        },
        DetailDescription: {
          y: _constants.Description.marginTop,
          x: _constants.Description.marginLeft,
          type: DetailDescription,
          miniDetail: true,
        },
      },
    };
  }

  set backend(backend) {
    this._backend = backend;
  }

  set updateUI(data) {
    // console.log(data);
    this.tag('DetailDescription').content = data;
    this.tag('PosterImage').texture.src = '';
    this.tag('PosterImage').texture.src = data.image;
    // this.tag('PosterImage').src = url;
  }

  get height() {
    return _constants.miniDetailHeight;
  }
}
